import { render } from "./GaleryComponent.vue?vue&type=template&id=48b7e654&scoped=true"
import script from "./GaleryComponent.vue?vue&type=script&lang=js"
export * from "./GaleryComponent.vue?vue&type=script&lang=js"

import "./GaleryComponent.vue?vue&type=style&index=0&id=48b7e654&scoped=true&lang=css"
import "./GaleryComponent.vue?vue&type=style&index=1&id=48b7e654&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b7e654"]])

export default __exports__